export default "__VITE_ASSET__BHLUpQQ5__"